import React, { Component } from 'react';
import classnames from 'classnames';
/**
 * 单选图片
 */
export default class ShowcaseUpload extends Component<any> {
    state = {
        uploadLoading: false,
    };
    render() {
        const { value, tips, className, onClick, style } = this.props;
        const uploadTips = <div className="upload-tips">{`${tips}`}</div>;

        return (
            <div className={classnames('showcase-item', className)} style={style} onClick={onClick}>
                {value ? (
                    <img className={classnames('showcase-pic')} src={value} alt="item-pic" />
                ) : (
                    uploadTips
                )}
            </div>
        );
    }
}
